import React, { useContext, useEffect, useRef, useState } from 'react';
import pt from 'prop-types';

import * as styles from './styles.module.scss';
import Icon from '../../../../ui/icon';
import { combine } from '../../../../../helpers/styles';
import Text from '../../../../ui/text';
import Container from '../../../../../modules/container';
import { renderDynamicComponents } from '../dynamicRenderer';

const AccordionItem = ({
  headline,
  content,
  isFirst,
  onOpen,
  isOpen,
  isSmallHeadline,
}) => {
  const ref = useRef();
  const outerContainerRef = useRef();
  const [maxHeight, setMaxHeight] = useState('none');

  const style = {
    transition: 'max-height 350ms ease-in-out',
    overflow: 'hidden',
    // For the collapse animation to work we need a fixed max-height,
    // therefore we simply pass the actual height of the element when the user collapses it (isOpen === false)
    maxHeight:
      maxHeight === 'none' && !isOpen ? ref.current?.clientHeight : maxHeight,
  };

  useEffect(() => {
    setMaxHeight(isOpen ? `${ref.current?.clientHeight + 50}px` : '0');
    if (isOpen) {
      // wait for animation to finish
      setTimeout(() => {
        const menu = document.querySelector('[class^="header-module--header"]');

        // navigation changes with scroll (on desktop -> sticky), so we need to check scroll direction
        const menuShown =
          window.getComputedStyle(menu).position === 'fixed' ||
          window.scrollY > outerContainerRef.current?.offsetTop;

        window.scrollTo({
          top:
            outerContainerRef.current?.offsetTop -
            (menuShown ? menu.getBoundingClientRect().height : 0),
          behavior: 'smooth',
        });
      }, 350);
    }
  }, [isOpen]);

  return (
    <Container className={styles.outerContainer} ref={outerContainerRef}>
      <button
        onClick={onOpen}
        className={combine(styles.header, isOpen && styles.isOpen)}
      >
        <Container
          className={combine(styles.headerContent, isFirst && styles.isFirst)}
          hasWhiteBg
        >
          <Text
            as="h2"
            type={isSmallHeadline ? 'h4' : 'h2'}
            className={combine(
              styles.leftAligned,
              isSmallHeadline && styles.small
            )}
          >
            {headline}
          </Text>
          <Icon
            name={isOpen ? 'chevron-up' : 'chevron-down'}
            className={styles.icon}
          />
        </Container>
      </button>
      <Container className={styles.contentContainer}>
        <div
          style={style}
          onTransitionEnd={() => {
            if (isOpen) {
              // To avoid problems when resizing the screen we simply reset max-height to default after ended transition
              setMaxHeight('none');
            }
          }}
        >
          <div className={styles.content} ref={ref}>
            {renderDynamicComponents(content)}
          </div>
        </div>
      </Container>
    </Container>
  );
};

export const accordionItemPropTypes = {
  headline: pt.string.isRequired,
  content: pt.array,
  isFirst: pt.bool,
};

AccordionItem.propTypes = accordionItemPropTypes;

AccordionItem.defaultProps = {
  content: [],
  isFirst: false,
};

export default AccordionItem;
